<template>
  <div>
    <div v-for="(year, yearindex) in YearList" :key="yearindex">
      <h3 v-if="GetYearFluData(year).length > 0">{{ year }}</h3>
      <a-row :gutter="16" v-if="GetYearFluData(year).length > 0">
        <a-col
          :span="8"
          :xs="24"
          :sm="12"
          :md="12"
          :lg="6"
          v-for="(item, index) in GetYearFluData(year)"
          :key="index"
          style="margin-bottom: 16px"
        >
          <a-card @click="FluClick(item)">
            <!-- 环比的一般计算方法：环比增长率=(本期数-上期数)/上期数×100% -->
            <a-row style="font-size: 16px; font-weight: bold">
              <a-col :span="12"> {{ item.fluTimeStr }}</a-col>
              <a-col
                :span="12"
                :style="item.totalChain > 0 ? UpStyle : DownStyle"
              >
                {{ item.totalChain }}%
                <i v-if="item.totalChain > 0" class="el-icon-top"></i>
                <i v-else class="el-icon-bottom"></i>
              </a-col>
            </a-row>
          </a-card>
        </a-col>
      </a-row>
    </div>

    <a-modal
      v-model:open="FluModelVisible"
      :title="amodelTitle"
      :width="amodelWidth"
      :wrap-class-name="amodelHeight"
    >
      <template #footer></template>
      <a-row v-if="SelFluData.totalChain != 0">
        <a-col :span="12" class="fluTitle">整体指数值日环比</a-col>
        <a-col
          :span="12"
          :class="SelFluData.totalChain > 0 ? 'fluUpData' : 'fluDownData'"
        >
          {{ SelFluData.totalChain }}
          <i v-if="SelFluData.totalChain > 0" class="el-icon-top"></i>
          <i v-else class="el-icon-bottom"></i>
        </a-col>
      </a-row>

      <a-row v-if="SelFluData.mpdocChain != 0">
        <a-col :span="12" class="fluTitle">公众号来源日环比</a-col>
        <a-col
          :span="12"
          :class="SelFluData.mpdocChain > 0 ? 'fluUpData' : 'fluDownData'"
        >
          {{ SelFluData.mpdocChain }}
          <i v-if="SelFluData.mpdocChain > 0" class="el-icon-top"></i>
          <i v-else class="el-icon-bottom"></i>
        </a-col>
      </a-row>
      <a-row v-if="SelFluData.expChain != 0">
        <a-col :span="12" class="fluTitle">视频号来源日环比</a-col>
        <a-col
          :span="12"
          :class="SelFluData.expChain > 0 ? 'fluUpData' : 'fluDownData'"
        >
          {{ SelFluData.expChain }}
          <i v-if="SelFluData.expChain > 0" class="el-icon-top"></i>
          <i v-else class="el-icon-bottom"></i>
        </a-col>
      </a-row>
      <a-row v-if="SelFluData.queryChain != 0">
        <a-col :span="12" class="fluTitle">搜一搜来源日环比</a-col>
        <a-col
          :span="12"
          :class="SelFluData.queryChain > 0 ? 'fluUpData' : 'fluDownData'"
        >
          {{ SelFluData.queryChain }}
          <i v-if="SelFluData.queryChain > 0" class="el-icon-top"></i>
          <i v-else class="el-icon-bottom"></i>
        </a-col>
      </a-row>
      <a-row v-if="SelFluData.liveChain != 0">
        <a-col :span="12" class="fluTitle">直播来源日环比</a-col>
        <a-col
          :span="12"
          :class="SelFluData.liveChain > 0 ? 'fluUpData' : 'fluDownData'"
        >
          {{ SelFluData.liveChain }}
          <i v-if="SelFluData.liveChain > 0" class="el-icon-top"></i>
          <i v-else class="el-icon-bottom"></i>
        </a-col>
      </a-row>
      <a-row v-if="SelFluData.extChain != 0">
        <a-col :span="12" class="fluTitle">网页来源日环比</a-col>
        <a-col
          :span="12"
          :class="SelFluData.extChain > 0 ? 'fluUpData' : 'fluDownData'"
        >
          {{ SelFluData.extChain }}
          <i v-if="SelFluData.extChain > 0" class="el-icon-top"></i>
          <i v-else class="el-icon-bottom"></i>
        </a-col>
      </a-row>
      <a-row v-if="SelFluData.adChain != 0">
        <a-col :span="12" class="fluTitle">其他来源日环比</a-col>
        <a-col
          :span="12"
          :class="SelFluData.adChain > 0 ? 'fluUpData' : 'fluDownData'"
        >
          {{ SelFluData.adChain }}
          <i v-if="SelFluData.adChain > 0" class="el-icon-top"></i>
          <i v-else class="el-icon-bottom"></i>
        </a-col>
      </a-row>

      <a-row>
        <div class="my-charts" ref="myfluChart"></div>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      FluData: [],
      KeywordData: [],
      YearList: [],
      UpStyle: {
        "text-align": "right",
        color: "green",
      },
      DownStyle: {
        "text-align": "right",
        color: "red",
      },
      FluModelVisible: false,
      amodelTitle: "",
      SelFluData: {},
      KeyWord: "",
      xAxisData: [],
      adScore: [],
      extlinkScore: [],
      liveScore: [],
      mpdocScore: [],
      queryScore: [],
      scoreExp: [],
      selectedRangeData: [],
    };
  },
  created() {
    this.checkIfMobile();
  },
  computed: {
    amodelHeight() {
      return this.isMobile ? "full-modal" : "helf-modal";
    },
    amodelWidth() {
      return this.isMobile ? "100%" : "50%";
    },
  },
  methods: {
    GetYearList() {
      const currentYear = new Date().getFullYear();
      const startYear = 2021;
      this.YearList = [];

      // 从2021年到当前年份循环，添加到YearList数组中
      for (let year = currentYear; year >= startYear; year--) {
        this.YearList.push(year);
      }

      // 可以根据需要返回YearList或直接使用组件内的YearList数据
      return this.YearList;
    },
    SetData(data) {
      this.GetYearList();
      this.KeywordData = data;
    },
    SetFluData(data) {
      this.GetYearList();
      this.FluData = data.map((item) => {
        return {
          fluTime: item.fluTime,
          fluTimeStr: this.formatDate(item.fluTime), // 保持原始的 fluTime 格式
          totalChain: this.GetChain(item.todayTotalScore, item.yesTotalScore),
          adChain: this.GetChain(item.todayAdScore, item.yesAdScore),
          extChain: this.GetChain(item.todayExtLinkScore, item.yesExtLinkScore),
          liveChain: this.GetChain(item.todayLiveScore, item.yesLiveScore),
          mpdocChain: this.GetChain(item.todayMpdocScore, item.yesMpdocScore),
          queryChain: this.GetChain(item.todayQueryScore, item.yesQueryScore),
          expChain: this.GetChain(item.todayFinderScore, item.yesFinderScore),
        };
      });
    },
    FluClick(flu) {
      this.FluModelVisible = true;
      this.amodelTitle = flu.fluTimeStr;
      this.SelFluData = Object.assign(flu);

      // 获取选中项的日期
      const selectedDate = flu.fluTime;

      // 计算前三天和后三天的日期范围
      let threeDaysBefore = this.getNthDayBefore(selectedDate, 3);
      let threeDaysAfter = this.getNthDayAfter(selectedDate, 3);

      // 获取昨天的日期
      const yesterday = this.getYesterday();

      // 如果后三天超过昨天，则向前顺延
      if (threeDaysAfter > yesterday) {
        // 计算需要向前顺延的天数
        const daysToShift = threeDaysAfter - yesterday;
        // 调整前后日期范围，保持总共7天的数据
        threeDaysBefore -= daysToShift;
        threeDaysAfter = yesterday;
      }

      console.log(this.KeywordData); // 输出前三天的日期
      // 从KeywordData中过滤出日期范围内的七天数据
      this.selectedRangeData = this.KeywordData.filter((item) => {
        // 这里假设KeywordData中的项也有fluTime属性来表示日期
        return (
          item.infoTime >= threeDaysBefore && item.infoTime <= threeDaysAfter
        );
      }).sort((a, b) => a.infoTime - b.infoTime); // 按日期排序

      this.KeyWord = this.selectedRangeData[0].keyWord;
      this.xAxisData = this.selectedRangeData.map((item) => item.infoTime);
      this.adScore = this.selectedRangeData.map((item) => item.adScore);
      this.extlinkScore = this.selectedRangeData.map(
        (item) => item.extlinkScore
      );
      this.liveScore = this.selectedRangeData.map((item) => item.liveScore);
      this.mpdocScore = this.selectedRangeData.map((item) => item.mpdocScore);
      this.queryScore = this.selectedRangeData.map((item) => item.queryScore);
      this.scoreExp = this.selectedRangeData.map(
        (item) =>
          item.totalScore -
          item.adScore -
          item.extlinkScore -
          item.liveScore -
          item.mpdocScore -
          item.queryScore
      );
      this.$nextTick(() => {
        this.InitOptions();
      });
    },
    GetYearFluData(year) {
      return this.FluData.filter((item) => {
        return (
          item.fluTime >= year * 10000 && item.fluTime < (year + 1) * 10000
        );
      });
    },

    // 更新日期格式化方法以处理数字类型
    formatDate(dateNum) {
      // 确保输入是有效数字
      if (typeof dateNum !== "number" || isNaN(dateNum)) {
        return dateNum;
      }

      // 将数字转换为字符串并确保是8位（可能需要补零）
      const dateStr = String(dateNum).padStart(8, "0");

      // 提取年月日
      const year = dateStr.substring(0, 4);
      const month = dateStr.substring(4, 6);
      const day = dateStr.substring(6, 8);

      // 返回格式化后的日期
      return `${year}年${month}月${day}日`;
    },
    GetChain(thisData, lastData) {
      if (!lastData || lastData === 0) {
        return 0;
      }

      // 计算环比增长率并保留两位小数
      const result = ((thisData - lastData) / lastData) * 100;
      return Number(result.toFixed(2));
    },
    checkIfMobile() {
      // 通常以768px作为移动设备的断点
      this.isMobile = window.innerWidth <= 768;
    },
    // 获取指定日期的前n天
    getNthDayBefore(dateNum, n) {
      // 将数字日期转换为Date对象
      const dateStr = String(dateNum).padStart(8, "0");
      const year = parseInt(dateStr.substring(0, 4));
      const month = parseInt(dateStr.substring(4, 6)) - 1; // 月份从0开始
      const day = parseInt(dateStr.substring(6, 8));

      const date = new Date(year, month, day);
      date.setDate(date.getDate() - n);

      // 将Date对象转回数字格式
      const newYear = date.getFullYear();
      const newMonth = String(date.getMonth() + 1).padStart(2, "0");
      const newDay = String(date.getDate()).padStart(2, "0");

      return parseInt(`${newYear}${newMonth}${newDay}`);
    },

    // 获取指定日期的后n天
    getNthDayAfter(dateNum, n) {
      // 将数字日期转换为Date对象
      const dateStr = String(dateNum).padStart(8, "0");
      const year = parseInt(dateStr.substring(0, 4));
      const month = parseInt(dateStr.substring(4, 6)) - 1; // 月份从0开始
      const day = parseInt(dateStr.substring(6, 8));

      const date = new Date(year, month, day);
      date.setDate(date.getDate() + n);

      // 将Date对象转回数字格式
      const newYear = date.getFullYear();
      const newMonth = String(date.getMonth() + 1).padStart(2, "0");
      const newDay = String(date.getDate()).padStart(2, "0");

      return parseInt(`${newYear}${newMonth}${newDay}`);
    },

    // 获取昨天的日期（数字格式）
    getYesterday() {
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);

      const year = yesterday.getFullYear();
      const month = String(yesterday.getMonth() + 1).padStart(2, "0");
      const day = String(yesterday.getDate()).padStart(2, "0");

      return parseInt(`${year}${month}${day}`);
    },
    InitOptions() {
      this.chart = this.$echarts.init(this.$refs.myfluChart);
      this.chart.setOption({
        color: [
          "#80FFA5",
          "#00DDFF",
          "#37A2FF",
          "#FF0087",
          "#FFBF00",
          "#00FF00",
        ],
        title: {
          text: this.KeyWord,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          data: ["其他", "网页", "直播", "公众号", "搜一搜", "视频号"],
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xAxisData,
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              formatter: function (value) {
                // 超过1亿用b
                if (value >= 100000000) {
                  return value / 100000000 + " B";
                }
                // 超过1百万用m
                else if (value >= 1000000) {
                  return value / 1000000 + " M";
                }
                // 超过1千用k
                else if (value >= 1000) {
                  return value / 1000 + " K";
                }
                // 小于1千直接返回原值
                return value;
              },
            },
          },
        ],
        series: [
          {
            name: "其他",
            type: "line",
            stack: "Total",
            smooth: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(128, 255, 165)",
                },
                {
                  offset: 1,
                  color: "rgb(1, 191, 236)",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
            data: this.adScore,
          },
          {
            name: "网页",
            type: "line",
            stack: "Total",
            smooth: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(0, 221, 255)",
                },
                {
                  offset: 1,
                  color: "rgb(77, 119, 255)",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
            data: this.extlinkScore,
          },
          {
            name: "直播",
            type: "line",
            stack: "Total",
            smooth: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(55, 162, 255)",
                },
                {
                  offset: 1,
                  color: "rgb(116, 21, 219)",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
            data: this.liveScore,
          },
          {
            name: "公众号",
            type: "line",
            stack: "Total",
            smooth: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(255, 0, 135)",
                },
                {
                  offset: 1,
                  color: "rgb(135, 0, 157)",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
            data: this.mpdocScore,
          },
          {
            name: "搜一搜",
            type: "line",
            stack: "Total",
            smooth: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            label: {
              show: true,
              position: "top",
            },
            areaStyle: {
              opacity: 0.8,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(255, 191, 0)",
                },
                {
                  offset: 1,
                  color: "rgb(224, 62, 76)",
                },
              ]),
            },

            emphasis: {
              focus: "series",
            },
            data: this.queryScore,
          },
          {
            name: "视频号",
            type: "line",
            stack: "Total",
            smooth: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            label: {
              show: true,
              position: "top",
            },
            areaStyle: {
              opacity: 0.8,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(255, 191, 0)",
                },
                {
                  offset: 1,
                  color: "rgb(224, 62, 76)",
                },
              ]),
            },

            emphasis: {
              focus: "series",
            },
            data: this.scoreExp,
          },
        ],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.fluTitle {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
}
.fluUpData {
  font-size: 20px;
  font-weight: bold;
  color: green;
  text-align: center;
}
.fluDownData {
  font-size: 20px;
  font-weight: bold;
  color: red;
  text-align: center;
}

.my-charts {
  width: 100%; // 设置宽度为100%，使其适应父容器
  height: 30vh; // 设置固定高度，可根据需要调整
}
</style>